export function measureStart(name) {
    if (window.performance) {
        window.performance.mark(`${name}.start`);
    }
}

export function measureEnd(name) {
    if (window.performance) {
        window.performance.mark(`${name}.end`);
        window.performance.measure(name, `${name}.start`, `${name}.end`);
    }
}
